import React from "react";
import { useWatch } from "react-hook-form";
import { FormGroup } from "reactstrap";
import { calcularTotalGrupo } from "views/ManutencaoDRE/gruposDespesa";
import CampoAjuda from "components/Inputs/CampoAjuda";

// [DTS-7122] Subtotal somente-leitura por grupo de despesa. Usa useWatch isolado
// (só os campos do próprio grupo) para não re-renderizar os ~103 inputs não
// controlados da tela inteira a cada tecla digitada.
// Título e valor ficam na mesma barra azul (ajuste de layout do teste e2e).
export default function SubtotalGrupo({ control, grupo, indicador }) {
    const nomes = grupo.campos.map(campo => campo.name);
    const observados = useWatch({ control, name: nomes }) || {};

    const total = calcularTotalGrupo(grupo, observados, indicador);

    return (
        <FormGroup className="subtotalGrupo">
            <div className="subtotalGrupoBarra">
                <span>{grupo.label} (R$) {grupo.ajuda && <CampoAjuda texto={grupo.ajuda} />}</span>
                <span>{total.toFixed(2).replace(".", ",")}</span>
            </div>
        </FormGroup>
    );
}
